// Cadena de "Tu gym facial, en casa" (pedido de Max, 2026-11-04): en movil se desliza sola, muy lento, una vez que se
// ve, y se queda en el ultimo paso. Si la persona la toca, se detiene y queda en sus manos.
(() => {
  const SPEED = 16; // px por segundo
  const start = (el) => {
    if (el.dataset.cfmAuto) return;
    el.dataset.cfmAuto = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let raf = 0;
    let last = 0;
    let pos = el.scrollLeft;
    const stop = () => {
      cancelAnimationFrame(raf);
      raf = 0;
    };
    const tick = (now) => {
      const max = el.scrollWidth - el.clientWidth;
      if (max <= 1) return;
      pos = Math.min(max, pos + (SPEED * (now - (last || now))) / 1000);
      last = now;
      el.scrollLeft = pos;
      if (pos < max) raf = requestAnimationFrame(tick);
      else raf = 0;
    };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((type) => el.addEventListener(type, stop, { passive: true, once: true }));
    new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      if (el.scrollWidth - el.clientWidth <= 1) return;
      el.style.scrollSnapType = 'none';
      raf = requestAnimationFrame(tick);
    }, { threshold: 0.6 }).observe(el);
  };
  const init = () => document.querySelectorAll('.cfm__cadena').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
